exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n\n// ---------------------- phone mediaq\n\t@include media($phone) {\n\t}\n// ---------------------- tablet mediaq\n\t@include media($tablet) {\n\t}\n// ---------------------- desktop mediaq\n\t@include media($desktop) {\n\t}\n\n*/\n.Tab {\n  width: 100%; }\n  .Tab__Content {\n    width: 100%; }\n", ""]);

// exports
